import XmlFormatter from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/XmlFormatter";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import { rowIsPacked } from "@ext/markdown/elements/table/edit/logic/formatters/xml/packing";

const tableRowFormatter: NodeSerializerSpec = async (state, node) => {
	const openTag = XmlFormatter.openTag("tr");
	const closeTag = XmlFormatter.closeTag("tr");

	if (rowIsPacked(node)) {
		state.write(openTag);
		for (let index = 0; index < node.childCount; index++) await state.render(node.child(index), node, index);
		state.write(closeTag);
		state.closeBlock(node);
		return;
	}

	await state.wrapContainer(openTag, closeTag, node, async () => await state.renderStructuralChildren(node));
};

export default tableRowFormatter;
